import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../components/footer/index';

const features = [
  { title: 'Microsoft 365', desc: 'Lisensi resmi Microsoft 365 Business untuk produktivitas tim dengan Word, Excel, Teams.', icon: '📝' },
  { title: 'Windows Server', desc: 'Lisensi Windows Server untuk infrastruktur on-premise dan hybrid cloud.', icon: '🖥️' },
  { title: 'SQL Server', desc: 'Database enterprise Microsoft SQL Server dengan dukungan teknis penuh.', icon: '🗃️' },
  { title: 'Azure Subscription', desc: 'Partner resmi Microsoft Azure untuk layanan cloud computing global.', icon: '☁️' },
  { title: 'Security & Compliance', desc: 'Microsoft Defender, Intune, dan solusi keamanan endpoint terintegrasi.', icon: '🛡️' },
  { title: 'Volume Licensing', desc: 'Program volume licensing dengan harga khusus untuk enterprise dan institusi pendidikan.', icon: '📋' },
];

const MicrosoftLicensingPage = () => {
  React.useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <section className="relative bg-gradient-to-br from-blue-900 via-sky-800 to-blue-700 text-white py-24 px-4">
        <div className="max-w-6xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Microsoft Licensing</h1>
          <p className="text-lg md:text-xl text-blue-200 max-w-3xl mx-auto">
            Partner resmi Microsoft untuk lisensi software enterprise, deployment, dan dukungan teknis berkelanjutan.
          </p>
        </div>
      </section>

      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800 dark:text-white">Produk Microsoft</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((f) => (
              <div key={f.title} className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
                <div className="text-4xl mb-4">{f.icon}</div>
                <h3 className="text-xl font-bold mb-3 text-gray-800 dark:text-white">{f.title}</h3>
                <p className="text-gray-600 dark:text-gray-300">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-sky-900 text-white py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4">Dapatkan Lisensi Resmi</h2>
          <p className="text-sky-200 mb-8">Konsultasikan kebutuhan lisensi Microsoft Anda untuk penawaran terbaik.</p>
          <Link to="/kontak" className="inline-block bg-white text-sky-900 font-bold px-8 py-4 rounded-xl hover:bg-sky-50 transition-colors">
            Minta Penawaran
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MicrosoftLicensingPage;
